export const testimonials = [
  {
    initials: 'MP',
    name: 'María P.',
    location: 'Madrid',
    flag: '🇪🇸',
    text: 'Compré un sábado. El domingo por la noche tenía el mes de sesiones listo. Nunca más improviso. Mis alumnas notan la diferencia. Las clases fluyen.'
  },
  {
    initials: 'CG',
    name: 'Claudia G.',
    location: 'Ciudad de México',
    flag: '🇲🇽',
    text: 'Tenía 15 alumnas estancadas en intermedio. Usé el Tomo 2 + el Bono de Progresiones. En 4 semanas, 12 de ellas progresaron. Me preguntaban qué había cambiado.'
  },
  {
    initials: 'FR',
    name: 'Federico R.',
    location: 'Bogotá',
    flag: '🇨🇴',
    text: 'Antes tardaba 1 hora preparando una sesión. Ahora son 5 minutos. Ese tiempo ahora lo uso para conseguir más alumnos. Gano más dinero en menos tiempo.'
  },
  {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Lima',
    flag: '🇵🇪',
    text: 'El Bono de Anatomía Visual cambió cómo corrijo a mis alumnos en el Reformer. Ahora sé exactamente qué músculo trabajar y qué cue dar. Mejoran más rápido.'
  },
  {
    initials: 'DA',
    name: 'Diego A.',
    location: 'Santiago',
    flag: '🇨🇱',
    text: 'El Checklist de Seguridad me salvó con una alumna con hernia lumbar. Supe exactamente qué hacer sin improvisar con su salud. Me siento profesional y protegido.'
  },
  {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Buenos Aires',
    flag: '🇦🇷',
    text: 'El Planner de Sesiones cambió mi relación con la enseñanza. Llego al estudio sabiendo exactamente qué voy a dar. Sin ansiedad. Sin culpa. Sin improvisación.'
  },
  {
    initials: 'JM',
    name: 'Juan M.',
    location: 'Valencia',
    flag: '🇪🇸',
    text: 'Vendía 2-3 clases privadas por mes. Con el sistema de planificación profesional, ahora vendo 10-12. El precio subió y la demanda también.'
  },
  {
    initials: 'LS',
    name: 'Laura S.',
    location: 'San José',
    flag: '🇨🇷',
    text: 'Soy nueva en Pilates. Esperaba tardar años en tener seguridad. Con esta enciclopedia, en 3 meses me siento como una profesora. Mis alumnas me creen.'
  },
  {
    initials: 'LM',
    name: 'Lucía M.',
    location: 'Bilbao',
    flag: '🇪🇸',
    text: 'Tenía miedo de que mis alumnas se dieran cuenta de que estaba usando una guía, pero fue al revés: me preguntaron si había hecho un máster nuevo porque las correcciones eran mucho más precisas.'
  }
];
